import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.bind";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@nerdwallet/react-button';
import { setTrk, TrkTag } from '@nerdwallet/nw-client-lib/trk-helper';
var COMPARE_PAGE_URL = '/compare/credit-cards';

var CompareLink =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CompareLink, _React$Component);

  var _super = _createSuper2(CompareLink);

  function CompareLink(props) {
    var _this;

    _classCallCheck(this, CompareLink);

    _this = _super.call(this, props);
    _this.state = {
      isAnimating: false
    };
    _this.setAnimatingStatus = _this.setAnimatingStatus.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CompareLink, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var ANIMATION_DURATION_MS = 500;
      var currentCount = this.props.numCardsToCompare;
      var nextCount = nextProps.numCardsToCompare;

      if (currentCount && nextCount && nextCount !== currentCount) {
        if (this.animationTimeout) {
          clearTimeout(this.animationTimeout);
        }

        this.setState({
          isAnimating: true
        });
        this.animationTimeout = setTimeout(this.setAnimatingStatus.bind(this, false), ANIMATION_DURATION_MS);
      }
    }
  }, {
    key: "setAnimatingStatus",
    value: function setAnimatingStatus() {
      var isAnimating = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.setState({
        isAnimating: isAnimating
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isActive = _this$props.isActive,
          numCardsToCompare = _this$props.numCardsToCompare,
          taxonomy = _this$props.taxonomy;
      var linkClasses = classNames('compare-link', 'ripply', {
        active: isActive,
        animate: this.state.isAnimating
      });
      var countClasses = classNames('count', 'rel', this.props.buttonClassName, {
        animate: this.state.isAnimating
      });
      var compareLink;

      if (this.props.overrideCTA) {
        compareLink = this.props.overrideCTA;
      } else {
        var compareAnchor = setTrk({
          url: COMPARE_PAGE_URL,
          taxonomy: taxonomy,
          params: _defineProperty({}, TrkTag.location, 'cc-compare-bar-compare-button')
        });
        compareLink = React.createElement(Button, {
          primary: true,
          href: compareAnchor,
          className: linkClasses
        }, React.createElement("div", {
          className: "compare-link__content"
        }, React.createElement("span", {
          className: "rel"
        }, this.props.ctaText), React.createElement("span", {
          className: countClasses
        }, React.createElement("span", null, numCardsToCompare))));
      }

      return compareLink;
    }
  }]);

  return CompareLink;
}(React.Component);

CompareLink.propTypes = {
  numCardsToCompare: PropTypes.number,
  isActive: PropTypes.bool,
  buttonClassName: PropTypes.string,
  overrideCTA: PropTypes.node,
  ctaText: PropTypes.string,
  taxonomy: PropTypes.shape({})
};
CompareLink.defaultProps = {
  ctaText: 'Compare Cards',
  taxonomy: {}
};
export default CompareLink;
//# sourceMappingURL=compare-link.js.map